import { createRootRoute, Outlet } from '@tanstack/react-router';
import React, { Suspense } from 'react';

import { AccountStatusGate } from '@/components/account-status-gate';
import { AnalyticsPageView } from '@/components/analytics-page-view';
import { EmailVerificationGate } from '@/components/email-verification-gate';
import { FirebaseErrorListener } from '@/components/FirebaseErrorListener';
import { GoogleTagManager } from '@/components/google-tag-manager';
import { ConditionalAppShell } from '@/components/layout/conditional-app-shell';
import { CookieConsent } from '@/components/layout/cookie-consent';
import { GlobalErrorComponent } from '@/components/layout/global-error-component';
import { MicrosoftClarity } from '@/components/microsoft-clarity';
import { MuiToaster } from '@/components/mui-toaster';
import { ThemePreferenceSync } from '@/components/theme-preference-sync';
import { NovelProvider } from '@/context/novel-context';
import { UIProvider } from '@/context/ui-context';
import { UserNovelsProvider } from '@/context/user-novels-context';
import { UserSessionProvider } from '@/context/user-session-context';

const TanStackRouterDevtools =
  // Router devtools are intentionally disabled in all environments.
  // eslint-disable-next-line no-constant-condition
  true //import.meta.env.PROD
    ? () => null
    : React.lazy(() =>
      import('@tanstack/router-devtools').then((res) => ({
        default: res.TanStackRouterDevtools,
      })),
    );

export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: GlobalErrorComponent,
});

function RootComponent() {
  return (
    <>
      <FirebaseErrorListener />
      <UIProvider>
        <EmailVerificationGate>
          <UserSessionProvider>
            <ThemePreferenceSync />
            <AccountStatusGate>
              <UserNovelsProvider>
                <NovelProvider>
                  <ConditionalAppShell>
                    <Outlet />
                  </ConditionalAppShell>
                </NovelProvider>
              </UserNovelsProvider>
            </AccountStatusGate>
          </UserSessionProvider>
        </EmailVerificationGate>
      </UIProvider>
      <MuiToaster />
      <CookieConsent />
      <AnalyticsPageView />
      <GoogleTagManager />
      <MicrosoftClarity />
      <Suspense>
        <TanStackRouterDevtools position="bottom-right" />
      </Suspense>
    </>
  );
}
